import { VEHICLE_LAST_KNOWN_DATA_SUBSCRIPTION } from './gql';
import { useSubscription } from '@apollo/client';
import { mapGpsEntityDTO } from './vehicle.mapper';
import { useLatestBufferedThrottle } from '../../hooks/useLatestBufferedThrottle';
const mapGpsDataToGpsDto = (dto) => {
    return {
        instant: dto.instant ? dto.instant.toString() : null,
        position: dto.position,
    };
};
export const useLastVehiclePositionSubscription = (options) => {
    const response = useSubscription(VEHICLE_LAST_KNOWN_DATA_SUBSCRIPTION);
    const data = response.data && response.data.vehicleLastKnowData;
    useLatestBufferedThrottle(data, 'asset.vehicleId', (buffered) => {
        const missingVehicles = buffered.filter((d) => !options.vehicleIds.includes(d.asset.vehicleId));
        if (missingVehicles.length) {
            options.onMissingVehicleUpdate();
        }
        const vehicleData = buffered
            .filter((d) => options.vehicleIds.includes(d.asset.vehicleId))
            .map((v) => {
            return {
                vehicleStatus: v.vehicleStatus,
                vehicleId: v.asset.vehicleId,
                vehicleGps: mapGpsEntityDTO({ gps: mapGpsDataToGpsDto(v.gps) }),
            };
        });
        if (vehicleData.length) {
            options.onChange(vehicleData);
        }
    });
};
export const useLastKnownVehicleData = (options) => {
    useSubscription(VEHICLE_LAST_KNOWN_DATA_SUBSCRIPTION, {
        onSubscriptionData: ({ subscriptionData }) => {
            const data = subscriptionData.data && subscriptionData.data.vehicleLastKnowData;
            if (data &&
                options.vehicleId &&
                data.asset.vehicleId === options.vehicleId) {
                options.onChange(data);
            }
        },
    });
};
//# sourceMappingURL=vehicles.subscription.js.map